import { Component, OnInit, ViewChild, AfterViewInit, Output, EventEmitter, Input } from '@angular/core';
import { PageNotFoundModel } from './PageNotFound.model';
import { ButtonComponent } from '../button/button.component';
import { FormComponent } from '../form/form.component';
import { ServiceStock } from '../service-stock.service';

const customCss: string = '.btn-primary {  font-size: 12px !important;  background: #007cbb!important; } .content-card {  box-shadow: 0 1px 3px 0 rgba(0,0,0,0.2);  border-radius: 5px; } .blue-text{  font-size: 35px!important;  color: rgb(1, 125, 187)!important;  font-family: inherit;  font-style: normal;  font-weight: 600!important; } .black-text{  color: black!important;  font-weight: 500!important; }';

@Component({
selector: 'app-PageNotFound',
templateUrl: './PageNotFound.component.html'
})
export class PageNotFoundComponent extends FormComponent implements OnInit, AfterViewInit {
@ViewChild('return', {static: false}) return: ButtonComponent;
async revalidate(): Promise<number> {
var totalErrors = 0;
super.beforeRevalidate();
await Promise.all([
]).then((errorCounts) => {
errorCounts.forEach((errorCount)=>{
totalErrors+=errorCount;
});
});
this.errors = totalErrors;
super.afterRevalidate();
return totalErrors;
}
constructor(services: ServiceStock){
super(services);
this.value = new PageNotFoundModel();
this.componentCode = 'PageNotFound';
this.displayBorder = false;
}
setReadOnly(readOnly){
super.setBasicFieldsReadOnly(readOnly);
}
async onFormLoad(){
this.setInputs(this.services.dataStore.getData(this.services.routing.currModal));
this.setDependencies();
}
setInputs(param : any){
let params = this.services.http.mapToJson(param);
if(params['mode']){
this.mode = params['mode'];
}
}
async submitForm(path, apiCode, serviceCode){
this.submitData['formName'] = '404 Error Not Found Component';
await super.submit(path, apiCode, serviceCode);
}
getFieldInfo() {
this.amountComponent.forEach(field => {this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo();});
this.comboFields.forEach(field => {this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo();});
// this.fileUploadFields.forEach(field => {this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo();});
return this.additionalInfo;
}
getFieldValue(){
return this.value;
}
setValue(inputValue, inputDesc=undefined) {
this.setBasicFieldsValue(inputValue, inputDesc);
this.value = new PageNotFoundModel();
this.value.setValue(inputValue);
this.setDependencies();
this.passNewValue(this.value);
}
ngOnInit(){
if(this.formCode == undefined) {this.formCode = 'PageNotFound';}
if(this.formOnLoadError){return;}
var styleElement = document.createElement('style');
styleElement.type = 'text/css';
styleElement.innerHTML = customCss;
styleElement.id = 'PageNotFound_customCss';
document.getElementsByTagName('head')[0].appendChild(styleElement);
}
ngOnDestroy(){
this.unsubscribe$.next();
this.unsubscribe$.complete();
var styleElement = document.getElementById('PageNotFound_customCss');
styleElement.parentNode.removeChild(styleElement);
}
ngAfterViewInit(){
setTimeout(() => {
this.subsBFldsValueUpdates();
this.onFormLoad();
this.checkForHTabOverFlow();
});
}
clearError(){
super.clearBasicFieldsError();
super.clearHTabErrors();
super.clearVTabErrors();
this.errors = 0;
this.errorMessage = [];
}
onReset(){
super.resetBasicFields();
this.clearHTabErrors();
this.clearVTabErrors();
this.errors = 0;
this.errorMessage = [];
this.additionalInfo = undefined;
this.dependencyMap.clear();
this.value = new PageNotFoundModel();
this.passNewValue(this.value);
this.setReadOnly(false);
this.onFormLoad();
}
async return_click(event){
let inputMap = new Map();
var navPath = ('/home').split('/');
navPath = navPath.slice(1);
inputMap.clear();
this.services.dataStore.setRouteParams(this.services.routing.currModal, inputMap);
if (this.services.routing.currModal > 0) {
var routerOutlets = {};
routerOutlets[this.services.routing.currOutlet] = [navPath[navPath.length-1], 'popup'];
this.services.router.navigate([{ outlets: routerOutlets }], { skipLocationChange: true });
} else {
this.services.router.navigate(navPath);
}
}
fieldDependencies = {
}

}